import { render, staticRenderFns } from "./CalendarFullYear.vue?vue&type=template&id=0337fc50&scoped=true"
import script from "./CalendarFullYear.vue?vue&type=script&lang=js"
export * from "./CalendarFullYear.vue?vue&type=script&lang=js"
import style0 from "./CalendarFullYear.vue?vue&type=style&index=0&id=0337fc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0337fc50",
  null
  
)

export default component.exports